'use client';

import { Reviews } from '@eliadmin/core/src/components/homepage/reviews';
import { CarouselProvider } from '@eliadmin/core/src/components/ui/carousel-context';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef, useState } from 'react';
import { storeReviewsQueryOptions } from '@/utils/store-reviews-query';

export function DeferredStoreReviews({ locale, title }: { locale: string; title: string }) {
  const container = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const { data } = useQuery({ ...storeReviewsQueryOptions(locale), enabled: visible });
  useEffect(() => {
    if (!container.current) return;
    if (typeof IntersectionObserver === 'undefined') {
      setVisible(true);
      return;
    }
    const observer = new IntersectionObserver(
      entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        setVisible(true);
        observer.disconnect();
      },
      { rootMargin: '300px' },
    );
    observer.observe(container.current);
    return () => observer.disconnect();
  }, []);
  return (
    <div ref={container} className="min-h-[360px]">
      {!!data?.length && (
        <CarouselProvider>
          <Reviews reviewsTitle={title} reviews={data} />
        </CarouselProvider>
      )}
    </div>
  );
}
